module.exports = __webpack_public_path__ + "prod/20260616192711/img/service.edbff227.png";